<template>
  <div v-if="options">
    <v-dialog scrollable v-model="dialogs.edit" persistent max-width="800px">
      <material-card :title="formTitle" icon="edit" :color="$vuetify.theme.themes.light.primary">
        <v-card-text>
          <v-stepper v-model="step" vertical>
            <v-stepper-step :complete="step > 1" step="1">
              {{ $t("components.memberview.select_effective_date") }}
            </v-stepper-step>
            <v-stepper-content step="1">
              <v-card>
                <v-card-text>
                  <v-form ref="effectiveForm" v-model="valid.effective">
                    <v-container fluid grid-list-md>
                      <v-row>
                        <v-col xs="12">
                          <pbas-date-picker
                            v-model="effectiveDate"
                            :value="effectiveDate"
                            @update-date="effectiveDate = $event"
                            :label="$t('components.inmemorydependants.effective_date')"
                            :rules="[$rules.required]"
                            class="required"
                          ></pbas-date-picker>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    :loading="loading"
                    :disabled="!loaded"
                    color="primary"
                    @click="step = 2"
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <v-stepper-step :complete="step > 2" step="2">
              {{ $t("views.taxes.update_tax") }}
            </v-stepper-step>
            <v-stepper-content step="2">
              <v-card>
                <v-card-text>
                  <v-form ref="taxForm" v-model="valid.tax" v-if="loaded">
                    <v-container fluid grid-list-md>
                      <v-row>
                        <v-col>
                          <!-- <auto-select
                            :value.sync="tax.TaxType"
                            :items="taxTypes"
                            :label="$t('globals.type')"
                            :rules="[$rules.required]"
                            class="required"
                            disabled
                            :slots="true"
                            :filter="filterFunc"
                          >
                            <template v-slot:selection="data">{{
                              $t("enums." + data.item)
                            }}</template>
                            <template v-slot:item="data">
                              <v-list-item-content
                                v-text="$t('enums.' + data.item)"
                              ></v-list-item-content>
                            </template>
                          </auto-select> -->
                          <trans-enum
                            :value.sync="tax.TaxType"
                            :items="taxTypes"
                            :label="$t('globals.type')"
                            disabled
                          ></trans-enum>
                        </v-col>
                        <v-col>
                          <currency-textfield
                            v-model="tax.TaxRate"
                            :label="$t('headers.taxes.rate')"
                            :rules="[
                              $rules.requiredNum,
                              $rules.dynamic.maxValue(100),
                            ]"
                            class="required"
                            prefix="%"
                          />
                          <!-- <no-autocomplete-textfield
                            v-model="tax.TaxRate"
                            :label="$t('headers.taxes.rate')"
                            :rules="[$rules.required]"
                            @keydown="currencyKeydown"
                            @keyup="currencyKeyUp"
                            @blur="rateBlur"
                            class="required"
                            prefix="%"
                          ></no-autocomplete-textfield> -->
                        </v-col>
                        <v-col>
                          <trans-select
                            v-if="!tax.IsFederal"
                            :item="tax.Identity"
                            propertyName="Province"
                            :items="provinces"
                            :label="$t('globals.province')"
                            :rules="[$rules.required]"
                            class="required"
                            :disabled="true"
                          ></trans-select>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-stepper-content>
          </v-stepper>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close()">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="isValid()"
            color="primary"
            :loading="saving"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <material-card :title="$t('components.vuematerialdashboard.core.appbar.taxes')" :color="$vuetify.theme.themes.light.secondary" icon="toll">
      <pbas-data-table
        :exporters="$exportersWithHistory"
        ref="table"
        :dataProvider="provider"
        :rowActions="rowActions"
        fileNamePrefix="taxes"
        identifier="taxesTable"
        :canExpand="(item) => item.Identity.HasHistory"
        :showExpand="true"
        :generateProviderForExpanded="(item) => generateProvider(item)"
        @error="error = $event"
      ></pbas-data-table>
    </material-card>
    <v-snackbar
      v-model="snackbar"
      :color="color"
      :multi-line="mode === 'multi-line'"
      :timeout="timeout"
      :vertical="mode === 'vertical'"
    >
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import TransSelect from "../components/TransSelect";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import TaxesHeaders from "../headers/Taxes";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import CurrencyTextfield from "../components/CurrencyTextfield.vue";
import TransEnum from "../components/TransEnum.vue";

export default {
  name: "taxes",
  components: {
    ErrorHandler,
    TransSelect,
    AutoSelect,
    NoAutocompleteTextfield,
    CurrencyTextfield,
    TransEnum,
  },
  mixins: [locker],
  data() {
    return {
      taxType: null,
      provinces: [],
      taxTypes: [],
      effectiveDate: null,
      taxId: null,
      loading: false,
      loaded: false,
      step: 1,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      valid: {
        effective: true,
        tax: true,
      },
      provider: undefined,
      saving: false,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.taxId = item.IdentityId;
            this.taxType = item.TaxType;
            this.dialogs.edit = true;
          },
        },
      ],
      dialogs: {
        edit: false,
      },
      headers: TaxesHeaders,
      tax: null,
      error: null,
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
    formTitle() {
      let name = "";
      if (this.taxType) {
        name = this.$t("enums." + this.taxType);
      }
      return this.$t("views.taxes.edit_{0}", [name]);
    },
  },
  mounted() {
    if (this.options) {
      this.provider = new PbasOData(this.$axiosHttp, "taxes", this.headers);
      this.taxTypes = this.options.Enums.TaxType;
      this.provinces = this.options.Models.Province;
    }
  },
  watch: {
    effectiveDate: {
      handler(v) {
        if (v) {
          this.loadDateDepended(v);
        } else {
          this.loaded = false;
        }
      },
    },
    options: {
      handler(v) {
        if (v) {
          this.provider = new PbasOData(this.$axiosHttp, "taxes", this.headers);
          this.taxTypes = this.options.Enums.TaxType;
          this.provinces = this.options.Models.Province;
        }
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["updateTax", "getTaxByEffectiveDate"]),
    isValid() {
      //console.log(this.valid.tax, this.loaded);
      return !this.valid.tax || !this.loaded;
    },
    // isNumeric(evt) {
    //   var iKeyCode = evt.which ? evt.which : evt.keyCode;
    //   if (
    //     iKeyCode != 46 &&
    //     iKeyCode > 31 &&
    //     (iKeyCode < 48 || iKeyCode > 57) &&
    //     (iKeyCode < 96 || iKeyCode > 105)
    //   )
    //     return false;

    //   return true;
    // },
    // currencyKeydown(evt, sender) {
    //   if (evt.keyCode == 8 || evt.keyCode == 46) {
    //     //console.log("delete");
    //     return;
    //   }
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   //console.log("V: ", value);
    //   if (!value) {
    //     if (evt.keyCode == 190 || evt.keyCode == 110) {
    //       el.value = value + "0.";
    //       el.setSelectionRange(2, 2);
    //     } /*else if (this.isNumeric(evt)) {
    //       el.value = value + ".00";
    //       el.setSelectionRange(0, 0);
    //     }*/
    //   } /*else if (parseFloat(value) && value.indexOf(".") == -1) {
    //     var start = el.selectionStart;
    //     el.value = value + ".00";
    //     el.setSelectionRange(start, start);
    //   }*/
    //   value = el.value;
    //   //console.log(value);
    //   if (
    //     (evt.keyCode == 190 || evt.keyCode == 110) &&
    //     value.indexOf(".") >= 0
    //   ) {
    //     el.setSelectionRange(value.indexOf(".") + 1, value.indexOf(".") + 1);
    //     evt.preventDefault();
    //     return;
    //   }
    //   //console.log(evt);

    //   if (
    //     evt.keyCode !== 190 &&
    //     evt.keyCode !== 110 &&
    //     !this.isNumeric(evt) &&
    //     (evt.keyCode < 35 || evt.keyCode > 40)
    //   ) {
    //     evt.preventDefault();
    //   } else if (evt.keyCode === 13) {
    //     evt.preventDefault();
    //   }
    // },
    // currencyKeyUp(evt) {
    //   var el = evt.srcElement;
    //   var value = el.value;
    //   // console.log(JSON.stringify({ v: value }));
    //   if (!value) return;
    //   var start = el.selectionStart;
    //   var end = el.selectionEnd;
    //   el.value = parseFloat(value).toFixed(4);
    //   if (start === 0 && end === 0) {
    //     end = 1;
    //   }
    //   el.setSelectionRange(start, end);
    //   // console.log("UP: ", el.value, value, start, end);
    // },
    // rateBlur() {
    //   this.tax.TaxRate = parseFloat(this.tax.TaxRate).toFixed(4);
    // },
    async loadDateDepended(date) {
      try {
        this.tax = await this.lock(
          this.getTaxByEffectiveDate,
          {
            id: this.taxId,
            date: date,
            expand: "$expand=Identity($expand=Province($expand=Translations))",
            dialogs: this.dialogs,
            dialog: "edit",
          },
          () => {
            this.dialogs.edit = false;
          }
        );

        // this.tax.EffectiveDate = date;
        this.tax.TaxRate = (parseFloat(this.tax.TaxRate) * 100).toFixed(2);
        this.loaded = true;
        //console.log(this.tax);
        // this.tax.TaxRate = parseFloat(this.tax.TaxRate).toFixed(4);
      } catch (error) {
        this.error = error;
      }
    },
    generateProvider(item) {
      let url =
        // "plans/" +
        // this.selectedPlan.Id +
        //"/"+
        "taxes/" + item.IdentityId + "/history";
      return new PbasOData(
        this.$axiosHttp,
        url,
        this.headers.filter(
          (o) =>
            (o.visible === true && o.allowVisibilityChange === true) ||
            o.allowVisibilityChange === false
        )
      );
    },
    trans(item, field) {
      return translate2(item, field);
    },
    close() {
      this.$refs.effectiveForm.resetValidation();
      this.dialogs.edit = false;
      this.loaded = false;
      this.effectiveDate = null;
      this.tax = null;
      this.step = 1;
    },
    save() {
      let item = JSON.parse(JSON.stringify(this.tax));
      item.TaxRate = (this.tax.TaxRate / 100).toFixed(6);
      this.update(item);
    },
    async update(item) {
      this.saving = true;
      item.TaxRate = parseFloat(item.TaxRate);
      if (item.Identity) {
        delete item.Identity;
      }
      delete item["@odata.context"];
      item.EffectiveDate = this.effectiveDate;
      try {
        await this.updateTax({
          id: item.IdentityId,
          payload: item,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.close();
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>
